// @flow
import React, { Component } from 'react';
import { DefaultIcon } from './Icon';
import { UpDownSwitchDiv } from './UpDownSwitchStyles';

type Props = {
  upFillColor: string,
  downFillColor: string
};

export default class UpDownSwitch extends Component<Props> {
  render() {
    return (
      <UpDownSwitchDiv>
        <DefaultIcon name="upSwitch" colorName={this.props.upFillColor} />
        <DefaultIcon name="downSwitch" colorName={this.props.downFillColor} />
      </UpDownSwitchDiv>
    );
  }
}
